import { Routes } from '@angular/router';

import { AuthService } from '../auth/auth.service';

import { ScorecardComponent } from './main-page/scorecard.component';

export const ScorecardRoutes: Routes = [
    {
        path: 'scorecard_v2',
        redirectTo: 'scorecards',
    },
    {
        path: 'scorecards',
        canActivate: [AuthService],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'me',
            },
            {
                path: ':userId',
                component: ScorecardComponent,
            },
            {
                path: ':userId/:scorecardId',
                component: ScorecardComponent,
            },
        ],
    },
];
